import { supabase } from '../lib/supabase'

export const simpleDbTest = async () => {
  try {
    console.log('Testing simple database connection...')
    
    // Test basic connection
    const { data, error } = await supabase
      .from('customers')
      .select('count')
      .limit(1)
    
    if (error) {
      console.error('Database test failed:', error)
      return {
        success: false,
        error: error.message,
        code: error.code
      }
    }
    
    console.log('Database connection successful')
    return {
      success: true,
      message: 'Database connection working'
    }
    
  } catch (error) {
    console.error('Database test error:', error)
    return {
      success: false,
      error: error.message
    }
  }
}

export const testSimpleCustomerCreate = async (testData) => {
  try {
    console.log('Testing simple customer creation...')
    
    const { data, error } = await supabase
      .from('customers')
      .insert([testData])
      .select()
      .single()
    
    if (error) {
      console.error('Customer creation test failed:', error)
      return {
        success: false,
        error: error.message,
        code: error.code,
        details: error
      }
    }
    
    console.log('Customer creation test successful:', data)
    
    // Clean up
    await supabase
      .from('customers')
      .delete()
      .eq('id', data.id)
    
    return {
      success: true,
      message: 'Customer creation test successful',
      data
    }
    
  } catch (error) {
    console.error('Customer creation test error:', error)
    return {
      success: false,
      error: error.message
    }
  }
}

